<template>
  <b-modal
    id="modal-view-identity"
    size="xl"
    centered
    title="Visualização"
    title-class="font-18"
    no-enforce-focus
    hide-footer
    @shown="downloadItem"
  >
    <div class="grid-tab">
      <div>
        <div>
          <a class="link" @click="dowloadDoc">Download dos Documentos</a>
          <hr />
          <p>
            <b class="text-primary">
              🖥️ {{ obj.is_mac ? 'Análise Mac/iOS' : 'Análise Convecional ' }}
            </b>
          </p>

          <p><b>Dados do Cliente</b></p>
          <div v-if="obj.user"><b>Nome:</b> {{ obj.user.name }}</div>
          <div v-if="obj.user"><b>E-mail:</b> {{ obj.user.email }}</div>
          <div v-if="obj.user"><b>{{ isHeaven ? 'Document' : 'CPF/CNPJ' }}:</b> {{ isHeaven ? obj.user.document_type + ': ' : '' }} {{ obj.user.cpf_cnpj }}</div>
          <div v-if="obj.user"><b>Telefone:</b> {{ obj.user.cellphone }}</div>
          <div v-if="obj.user && obj.user.rg && !isHeaven"><b>RG:</b> {{ obj.user.rg }}</div>
          <div v-if="obj.user"
            ><b>Data de Cadastro:</b> {{ formatDate(obj.user.created_at) }}</div
          >
          <div v-if="obj.user && obj.user.email_verified_at"
            ><b>Data de Verificação de E-mail:</b>
            {{ formatDate(obj.user.email_verified_at) }}</div
          >
        </div>
        <hr />
        <div v-if="!obj.is_mac">
          <p><b>Movimentos</b></p>
          <ul id="example-1">
            <li v-for="pose in JSON.parse(obj.poses)" :key="pose">
              {{ changePose(pose) }}
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div class="actions">
          <b-button
            v-if="obj.status === 'REQUESTED'"
            variant="success"
            class="mr-2"
            @click="accept(obj.id)"
          >
            <i class="fas fa-check"></i>
          </b-button>
          <b-button variant="danger" class="mr-2" @click="deny(obj.id)">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
        <p><b>Videos</b></p>
        <div v-show="!loading">
          <video
            id="preview"
            preload="auto"
            controls
            class="video"
            name="media"
          ></video>
          <p id="p"></p>
        </div>
        <div v-if="loading" class="row justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment'
import validAcessRoute from '@/src/utils/validAcessRoute'
import IdentityDownloadService from '@services/resources/IdentityDownloadService'
var service2 = IdentityDownloadService.build()

export default {
  props: ['obj', 'id'],
  data() {
    return {
      video: '',
      loading: false,
      showToAdminFinancial: validAcessRoute(
        ['financial'],
        this.$store.getters.getProfile
      ),
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    }
  },
  methods: {
    accept(e) {
      this.$emit('accept', e)
    },
    deny(e) {
      this.$emit('deny', e)
    },
    formatDate(e) {
      return moment(e).format('DD/MM/YYYY HH:mm')
    },
    dowloadDoc() {
      var path = this.obj.doc_back
      const ext = path.split('.').pop()
      let data = {
        path: path,
      }
      service2
        .blob2(data)
        .then((resp) => {
          const url = window.URL.createObjectURL(new Blob([resp]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `arquivo.${ext}`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(err => console.error(err))

      var path2 = this.obj.doc_front
      const ext2 = path2.split('.').pop()
      let data2 = {
        path: path2,
      }
      service2
        .blob2(data2)
        .then((resp) => {
          const url = window.URL.createObjectURL(new Blob([resp]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `arquivo.${ext2}`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(err => console.error(err))
    },
    downloadItem() {
      this.loading = true
      let data = {
        path: this.obj.video,
      }
      service2
        .blob2(data)
        .then((resp) => {
          var p = document.getElementById('preview')
          p.innerText = ''
          document.getElementById('preview').style.display = 'block'
          document.getElementById('preview').src = window.URL.createObjectURL(
            new Blob([resp], { type: 'video/mp4' })
          )
          document.getElementById('preview').src =
            document.getElementById('preview').src + '#t=1,20'
        })
        .catch((err) => {
          console.log(err)
          document.getElementById('preview').style.display = 'none'
          var p = document.getElementById('p')
          p.innerText = 'Video não Disponivel.'
        })
        .finally(() => {
          this.loading = false
        })
    },
    changePose(e) {
      switch (e) {
        case 'LOOK_UP':
          return 'Olhar para Cima'
        case 'LOOK_DOWN':
          return 'Olhar para Baixo'
        case 'LOOK_RIGHT':
          return 'Olhar para Direita'
        case 'LOOK_LEFT':
          return 'Olhar para Esquerda'
        case 'SMILE':
          return 'Sorrir'
        case 'BLINK':
          return 'Piscar'
        case 'TURN_LEFT':
          return 'Vire a Esquerda'
        case 'TURN_RIGHT':
          return 'Vire a Direita'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-tab {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.link {
  color: #00897b !important;
  text-decoration: none !important;
  background-color: transparent !important;
  cursor: pointer;
}

.link:hover {
  color: #006359 !important;
}

.video {
  width: 80%;
  border-radius: 3px;
}

.link {
  color: #00897b !important;
  text-decoration: none !important;
  background-color: transparent !important;
  cursor: pointer;
}

.link:hover {
  color: #006359 !important;
}

.actions {
  text-align: end;
}
</style>
